import { Component } from '@angular/core';
import { DataService } from '../data/data.service';
import swal from 'sweetalert2/dist/sweetalert2.js';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-teacher-menu-link',
  templateUrl: './teacher-menu-link.component.html',
  styleUrl: './teacher-menu-link.component.scss'
})
export class TeacherMenuLinkComponent {

  constructor(public dataService: DataService) {}

  loading: boolean = false;
  environment = environment;

  goToTeacherMenu() {
    // deep link to teacher menu
    this.loading = true;
    this.dataService.getAccountSSOToken().subscribe( x => {
        if(x.Token) {
          window.open(environment.PLAY_URL + "?tokenSource=SSO&token=" + x.Token, "_blank").focus();
          this.loading = false;
        } else {
          swal.fire('Oops!', 'Failed to deep link to teacher menu.', 'error');
          this.loading = false;
        }
    });
  }
}
